var _defs, _g, _g2, _path, _path2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmoticonVideoRating = function SvgEmoticonVideoRating(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 163.72 132.031"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "emoticon_video_rating_svg__a",
    width: 24.2,
    height: 24.2,
    x: 139.521,
    y: 41.271,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.412
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "emoticon_video_rating_svg__b",
    width: 24.2,
    height: 24.2,
    x: 139.521,
    y: 85.4,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.412
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "emoticon_video_rating_svg__c",
    width: 24.2,
    height: 24.2,
    x: 139.521,
    y: 0,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-3",
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.412
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-3",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Emoticon_Video_Rating",
    style: {
      mixBlendMode: "luminosity",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1901"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#42424f",
    stroke: "#42424f",
    "data-name": "Rectangle 318",
    transform: "translate(0 2.826)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 132,
    height: 106,
    stroke: "none",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 131,
    height: 105,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.13,
    transform: "translate(48.005 37.826)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18.103,
    cy: 18.103,
    r: 18.103,
    fill: "#f15a5c",
    "data-name": "Ellipse 118",
    transform: "translate(-.005)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42424f",
    d: "M14.166 30.169a.7.7 0 0 1-.323-.054.72.72 0 0 1-.431-.7V6.788a.72.72 0 0 1 .431-.7.86.86 0 0 1 .808.108l12.606 11.313a.786.786 0 0 1 0 1.185L14.651 29.953a.66.66 0 0 1-.485.216m.754-21.657v19.183l10.667-9.589Z",
    "data-name": "Path 467"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f15a5c",
    d: "M18.099 36.203a18.1 18.1 0 1 1 18.1-18.1 18.14 18.14 0 0 1-18.1 18.1m0-34.694a16.593 16.593 0 1 0 16.593 16.593A16.6 16.6 0 0 0 18.099 1.508Z",
    "data-name": "Path 468"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "play",
    transform: "translate(.005 117.326)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7.353,
    cy: 7.353,
    r: 7.353,
    fill: "#f15a5c",
    "data-name": "Ellipse 118",
    transform: "translate(-.005)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#42424f",
    d: "M5.751 12.254a.3.3 0 0 1-.131-.022.29.29 0 0 1-.175-.285v-9.19a.29.29 0 0 1 .175-.285.35.35 0 0 1 .328.044l5.12 4.6a.32.32 0 0 1 0 .481l-5.12 4.573a.27.27 0 0 1-.2.088Zm.306-8.8v7.79l4.332-3.895Z",
    "data-name": "Path 467"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f15a5c",
    d: "M7.348 14.704A7.352 7.352 0 1 1 14.7 7.352a7.37 7.37 0 0 1-7.352 7.352m0-14.092a6.739 6.739 0 1 0 6.739 6.739A6.74 6.74 0 0 0 7.348.613Z",
    "data-name": "Path 468"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e3e3e3",
    d: "M19 122.826h115v4H19z",
    "data-name": "Rectangle 346"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f15a5c",
    d: "M19 122.826h53v4H19z",
    "data-name": "Rectangle 347"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Emoticon_Vertical_Slider\\u200B"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 168"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#emoticon_video_rating_svg__a)",
    transform: "translate(.001 .001)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.1,
    cy: 9.1,
    r: 9.1,
    fill: "#e8d909",
    "data-name": "Ellipse 9",
    transform: "translate(142.52 44.27)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 10"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M146.549 51.655a1.3 1.3 0 1 1 1.3 1.3 1.3 1.3 0 0 1-1.3-1.3",
    "data-name": "Path 9"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M155.031 51.655a1.3 1.3 0 1 1 1.3 1.3 1.3 1.3 0 0 1-1.3-1.3",
    "data-name": "Path 10"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 13"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    "data-name": "Path 12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.122 56.53h-9.954l-.001-.25v.25a.596.596 0 0 1-.6-.587.58.58 0 0 1 .174-.42.6.6 0 0 1 .42-.174h9.961c.332 0 .6.263.601.587a.58.58 0 0 1-.174.42.6.6 0 0 1-.42.174z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.167 56.28h9.961a.345.345 0 0 0 .345-.343.344.344 0 0 0-.348-.338h-9.962a.344.344 0 0 0-.346.343c0 .187.158.338.35.338m9.962.5h-9.96a.847.847 0 0 1-.852-.836.83.83 0 0 1 .249-.599.85.85 0 0 1 .593-.246h9.963c.469 0 .85.375.851.836a.848.848 0 0 1-.842.846z"
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 168"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#emoticon_video_rating_svg__b)",
    transform: "translate(.001)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.1,
    cy: 9.1,
    r: 9.1,
    fill: "#f54f4f",
    "data-name": "Ellipse 9",
    transform: "translate(142.52 88.4)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#f54f4f",
    stroke: "#fff",
    "data-name": "Group 274"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.423 101.337a.34.34 0 0 1-.312-.477 5.308 5.308 0 0 1 9.74 0 .34.34 0 1 1-.617.288l-.008-.017a4.628 4.628 0 0 0-8.49 0 .34.34 0 0 1-.313.206Z",
    "data-name": "Path 18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.736 95.865a1.58 1.58 0 0 1-1.358-.784.4.4 0 1 1 .693-.4.768.768 0 0 0 1.3.045.4.4 0 0 1 .664.449 1.57 1.57 0 0 1-1.299.69Z",
    "data-name": "Path 19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.23 95.865a1.57 1.57 0 0 1-1.3-.692.4.4 0 0 1 .664-.449.767.767 0 0 0 1.066.206.8.8 0 0 0 .235-.251.4.4 0 1 1 .693.4 1.58 1.58 0 0 1-1.358.786Z",
    "data-name": "Path 20"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 168"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#emoticon_video_rating_svg__c)",
    transform: "translate(.001)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9.1,
    cy: 9.1,
    r: 9.1,
    fill: "#6cc959",
    "data-name": "Ellipse 9",
    transform: "translate(142.52 3)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 273"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6cc959",
    stroke: "#fff",
    d: "M157.678 12.837a.34.34 0 0 1-.306.195.35.35 0 0 1-.148-.034l-.208-.1a5.639 5.639 0 0 1-10.534 0l-.208.1a.3.3 0 0 1-.146.034.341.341 0 0 1-.147-.65l.964-.461a.341.341 0 1 1 .321.6l-.026.013-.141.065a4.96 4.96 0 0 0 9.3 0l-.141-.065a.34.34 0 1 1 .293-.614l.965.461a.34.34 0 0 1 .162.452Z",
    "data-name": "Path 2"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6cc959",
    stroke: "#fff",
    d: "M147.504 9.604a1.58 1.58 0 0 1-1.358-.78.4.4 0 0 1 .693-.4.768.768 0 0 0 1.3.045.4.4 0 0 1 .664.448 1.57 1.57 0 0 1-1.299.687Z",
    "data-name": "Path 3"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6cc959",
    stroke: "#fff",
    d: "M155.997 9.604a1.57 1.57 0 0 1-1.3-.692.4.4 0 1 1 .664-.449.77.77 0 0 0 1.067.2.8.8 0 0 0 .233-.25.4.4 0 0 1 .693.4 1.58 1.58 0 0 1-1.357.791Z",
    "data-name": "Path 4"
  })))))))));
};
export default SvgEmoticonVideoRating;